import React, { useState } from "react";
import styled from "styled-components";
import Button from "../../../../common/Button";

const ToolbarButton = styled(Button)`
  ${(props) => {
    if (props.isPressed) {
      return `
      background-color: #777;

      svg {
        fill: #fff !important;
      }

      &:hover {
        background-color: #666 !important;
      }
      `;
    }
  }}
`;

const Styled = styled.div`
  padding: 0.5rem;
  display: flex;
  gap: 0.5rem;

  background-color: #e7e7e7;
  margin-bottom: 1px;
  button {
    border: none;
    svg {
      display: block;
      fill: #555;
    }
  }

  button:hover {
    background-color: #d0d0d0;
  }
`;

interface Props {}

const Toolbar: React.FC<React.PropsWithChildren<Props>> & {
  Button: typeof ToolbarButton;
} = (props) => {
  return <Styled>{props.children}</Styled>;
};

Toolbar.Button = ToolbarButton;

export default Toolbar;
